import { Popover } from "@radix-ui/react-popover";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { useId, useState } from "react";

import { Button } from "@/components/ui/button";
import { DatetimePicker } from "@/components/ui/datetime-picker";
import { Label } from "@/components/ui/label";
import { PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn, cx } from "@/utils/cx";

export const DateTimeInput = ({
    value,
    onValue,
    label,
    disabled = false,
    autoFocus,
    className,
    validationError,
}: {
    value: Date | string | null;
    onValue: (value: Date) => void;
    label?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    className?: string;
    validationError?: string;
}) => {
    const id = useId();
    const [open, setOpen] = useState(false);

    return (
        <div className={cx("flex flex-col gap-2", className)}>
            {label ? <Label htmlFor={id}>{label}</Label> : null}
            <Popover open={open} onOpenChange={setOpen} modal>
                <PopoverTrigger asChild disabled={disabled} autoFocus={autoFocus}>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-[280px] justify-start text-left font-normal",
                            !value && "text-muted-foreground"
                        )}
                    >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {value ? format(value, "PPP HH:mm") : <span>Pick a date</span>}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-4">
                    <DatetimePicker
                        selected={
                            typeof value === "string" ? new Date(value) : (value ?? new Date())
                        }
                        setDate={onValue}
                        initialFocus
                    />
                </PopoverContent>
            </Popover>
            {validationError ? <div className="text-sm text-red-500">{validationError}</div> : null}
        </div>
    );
};
